import { OutliersBenchmarkStrategy } from 'widgets/outliers/data/benchmarksStrategies/index';
import isNil from 'lodash/isNil';

export const arrivalPriceBenchmarkStrategy: OutliersBenchmarkStrategy = {
    mapOrder: (order, exchangeRate) => {
        if (isNil(order.arrivalPD)) {
            return undefined;
        }

        return { benchmarkPrice: order.arrivalPD * exchangeRate };
    },
    getRequiredColumns: () => ['arrivalPD'],
};
